import { reduxActions } from '../constants';

export default class NavActions {
    static menuToggle(isOpen){
        return {
            type: reduxActions.MENU_TOGGLE,
            isOpen: isOpen
        }
    }
}



// WEBPACK FOOTER //
// ./web-app/actions/nav-actions.js